import React from 'react';
import style from '../css/footer.module.css';
import { Link } from 'react-router-dom';

const Footer = () => {

  return (
    <>
      <div id={style.fot_warp}>
        <div>
          <ul >
            <li>
              <Link to="/privacy">
                이용약관
              </Link>
            </li>
          </ul>
          ㈜캐치 / 고객센터 1800-1321 / (10391) 경기도 김포시 김포한강10로133번길 107 ,908,909,910호 (디원시티시그니처) <span className="br_pc" />
          Copyright@2024 CATCH. Registration Administrators All Rights Reserved.
        </div>
      </div>
    </>

  );
}

export default Footer;
